import BrandBrick from "@/components/landing/BrandBrick";

const links = [
  { href: "#services", label: "Services", id: "services" },
  { href: "#comparison", label: "Fair Pricing", id: "comparison" },
  { href: "#interactive", label: "Fix Diagnostic", id: "interactive" },
  { href: "#bonus", label: "Client Bonus", id: "bonus" },
  { href: "#deposit", label: "Deposit", id: "deposit" },
  { href: "#about", label: "About", id: "about" },
  { href: "#reviews", label: "Reviews", id: "reviews" },
];

export default function Nav() {
  return (
    <header className="sticky top-0 z-40 bg-[#232A31]/90 backdrop-blur-md border-b border-[#3A4752]">
      <div className="max-w-6xl mx-auto px-3 sm:px-6 min-h-24 flex items-center justify-between gap-3">
        <a href="#hero" aria-label="Will Fix It home" className="flex items-center shrink-0 transition-opacity hover:opacity-90" data-testid="nav-brand-link">
          <BrandBrick />
        </a>
        <nav aria-label="Main navigation" className="hidden lg:flex items-center gap-5 xl:gap-6 text-sm font-semibold text-[#D8D2CA]">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="hover:text-[#D4691E] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="nav-request-quote-btn"
          className="shrink-0 px-3 sm:px-5 py-2.5 rounded-md bg-[#D4691E] hover:bg-[#A94E10] text-white text-xs sm:text-sm font-semibold transition-colors shadow-sm"
        >
          Request Quote
        </a>
      </div>
    </header>
  );
}
